import styled from 'styled-components';

export const MainBodyContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  align-items: center;
`;
